export default __webpack_public_path__ + "static/media/stream.408c159b.png";